import React, { useState } from 'react';
import { useAllItemsQuery, useEditItemByIdMutation, useCreateItemMutation, useDeleteItemByIdMutation } from '../../../../store/api/item.api';
import styles from '../ItemsAdminPage.module.css';
import { useNavigate } from 'react-router-dom';
import { ItemModal } from '../../Modal/ItemModal/ItemModal';

export const ItemsAdminPage = () => {
	const { data: items = [], isLoading, refetch } = useAllItemsQuery({ schema: '' });
	const [activeMenu, setActiveMenu] = useState(null);
	const [editItemId, setEditItemId] = useState(null);
	const [createMode, setCreateMode] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const navigate = useNavigate();

	const ITEMS_PER_PAGE = 10;

	const [editItem] = useEditItemByIdMutation();
	const [createItem] = useCreateItemMutation();
	const [deleteItem] = useDeleteItemByIdMutation();

	const handleMenuToggle = (itemId) => {
		setActiveMenu((prev) => (prev === itemId ? null : itemId));
	};

	const handleEdit = (itemId) => {
		setEditItemId(itemId);
		setActiveMenu(null);
	};

	const handleCloseModal = () => {
		setEditItemId(null);
		setCreateMode(false);
	};

	const handleItemSubmit = async (formData, itemId = null) => {
		console.log(formData);
		if (itemId) {
			try {
				await editItem({ itemId, data: formData, schema: ''}).unwrap();
			} catch (error) {
				alert('Ошибка при обновлении товара');
			}
		} else {
			try {
				await createItem({data: formData, schema: ''}).unwrap();
			} catch (error) {
				alert('Ошибка при добавлении товара');
			}
		}
		refetch();
		handleCloseModal();
	};

	const handleDelete = async (itemId) => {
		if (window.confirm('Вы уверены, что хотите удалить этот товар?')) {
			try {
				await deleteItem({itemId, schema: ''}).unwrap();
			} catch (error) {
				alert('Ошибка при удалении товара');
			}
			refetch();
		}
	};

	// Фильтрация товаров по названию
	const filteredItems = items.filter((item) =>
		item.title.toLowerCase().includes(searchQuery.toLowerCase())
	);

	// Расчет, какие товары показывать на текущей странице
	const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
	const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
	const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

	// Расчет количества страниц
	const totalPages = Math.ceil(filteredItems.length / ITEMS_PER_PAGE);

	// Переключение на предыдущую страницу
	const paginatePrev = () => setCurrentPage(prev => Math.max(prev - 1, 1));

	// Переключение на следующую страницу
	const paginateNext = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));

	if (isLoading) {
		return <div className={styles.loading}>Загрузка...</div>;
	}

	return (
		<div className={styles.main}>
			<div className={styles.topBar}>
				<button onClick={() => navigate('/admin')} className={styles.backButton}>
					← Назад
				</button>
			</div>
			<h2 className={styles.title}>Товары</h2>

			<div className={styles.buttonWrapper}>
				<button className={styles.addButton} onClick={() => setCreateMode(true)}>
					Добавить игру
				</button>
			</div>

			<div className={styles.searchWrapper}>
				<input
					type="text"
					placeholder="Поиск по названию..."
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
					className={styles.searchInput}
				/>
			</div>

			<div className={styles.header}>
				<div>ID</div>
				<div>Название</div>
				<div>Цена</div>
				<div>Подписка</div>
				<div>Категория</div>
				<div>Жанр</div>
				<div>Язык</div>
				<div>inMainSlider</div>
				<div>Действия</div>
			</div>

			<div className={styles.list}>
				{currentItems.map((item) => (
					<div key={item.id} className={styles.row}>
						<div>{item.id}</div>
						<div>{item.title}</div>
						<div>{item.price} ₽</div>
						<div>{item.subscription ? 'Да' : 'Нет'}</div>
						<div>{item.category || '-'}</div>
						<div>{item.genres[0]?.title || '-'}</div>
						<div>{item.lang || '-'}</div>
						<div>{item.inMainSlider ? 'Да' : 'Нет'}</div>
						<div className={styles.actions}>
							<div onClick={() => handleMenuToggle(item.id)} className={styles.menuIcon}>
								⋮
							</div>
							{activeMenu === item.id && (
								<div className={styles.menu}>
									<div onClick={() => handleEdit(item.id)}>Изменить</div>
									<div onClick={() => handleDelete(item.id)}>Удалить</div>
								</div>
							)}
						</div>
					</div>
				))}
			</div>

			{/* Пагинация */}
			<div className={styles.pagination}>
				<button
					onClick={paginatePrev}
					disabled={currentPage === 1}
					className={styles.pageButton}
				>
					Назад
				</button>
				<span className={styles.pageInfo}>
					Страница {currentPage} из {totalPages}
				</span>
				<button
					onClick={paginateNext}
					disabled={currentPage === totalPages}
					className={styles.pageButton}
				>
					Вперёд
				</button>
			</div>

			{(editItemId || createMode) && (
				<ItemModal
					isOpen={editItemId !== null || createMode}
					onClose={handleCloseModal}
					onSubmit={(formData) => handleItemSubmit(formData, editItemId)}
					item={createMode ? null : items.find((item) => item.id === editItemId)}
				/>
			)}
		</div>
	);
};
